import * as React from "react";
import Dialog from "material-ui/Dialog";
import ActionButton, {ActionButtonType} from "components/Button/ActionButton";
import EventListener from "react-event-listener";

interface Props {
    message: React.ReactNode;
    callback(navigate: boolean): void;
}

interface State {
    show: boolean;
}

class ConfirmNavigate extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            show: true
        };
    }

    handleTouchTap = (navigate: boolean) => {
        this.setState({
            show: false
        });
        this.props.callback(navigate);
    }

    handleKeyDown = (event: any) => {
        if (event.keyCode === 27 /*esc*/) {
            this.handleTouchTap(false);
        }
    }

    render() {
            const actions = [
                <ActionButton
                    style={{marginRight: "5px"}}
                    key="discard"
                    label="Discard Changes"
                    onClick={() => this.handleTouchTap(true)}
                />,
                <ActionButton
                    key="cancel"
                    label="Cancel"
                    type={ActionButtonType.Primary}
                    keyboardFocused={true}
                    onClick={() => this.handleTouchTap(false)}
                />
            ];
            return <Dialog
                title="Unsaved Changes"
                actions={actions}
                modal={true}
                open={this.state.show}
                autoScrollBodyContent={true}>
                <EventListener target="document" onKeyDown={this.handleKeyDown} />
                {this.props.message}
            </Dialog>;
    }
}

export default ConfirmNavigate;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/ConfirmNavigate/ConfirmNavigate.tsx